import React from 'react';
import { IClassName } from '../../../constants';

const Trello: React.FC<IClassName> = ({ className }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className={className}>
      <path d="M2.5 7.83333C2.5 5.96667 2.5 5.03333 2.86333 4.32C3.18291 3.69282 3.69282 3.18291 4.32 2.86333C5.03333 2.5 5.96667 2.5 7.83333 2.5H12.1667C14.0333 2.5 14.9667 2.5 15.68 2.86333C16.3072 3.18291 16.8171 3.69282 17.1367 4.32C17.5 5.03333 17.5 5.96667 17.5 7.83333V12.1667C17.5 14.0333 17.5 14.9667 17.1367 15.68C16.8171 16.3072 16.3072 16.8171 15.68 17.1367C14.9667 17.5 14.0333 17.5 12.1667 17.5H7.83333C5.96667 17.5 5.03333 17.5 4.32 17.1367C3.69282 16.8171 3.18291 16.3072 2.86333 15.68C2.5 14.9667 2.5 14.0333 2.5 12.1667V7.83333Z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M14.1663 5.83301H11.6663V9.99967H14.1663V5.83301ZM8.33301 5.83301H5.83301V13.333H8.33301V5.83301Z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
};

export default Trello;
